// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AddEditContent_containers {
  overflow: hidden;
  height: 100vh;
}
.AddEditContent_containers .AddEditContent_container {
  width: 100%;
  display: flex;
  overflow: hidden;
}
.AddEditContent_containers .sidebar {
  width: 20%;
  background: #dde7f5;
}
.AddEditContent_containers .multiselect_input {
  min-width: 80% !important;
}
.AddEditContent_containers .multiselect-label {
  top: 11px !important;
  left: 4px !important;
}
:dir(rtl) .AddEditContent_containers .multiselect-label {
  left: auto !important;
  right: 30px !important;
}
.AddEditContent_containers .multiselect_input {
  height: 2.8rem !important;
  line-height: 45px;
}
.AddEditContent_containers .multiselect_part {
  margin-left: 10px !important;
  width: 100% !important;
  height: 2.8rem !important;
}
.AddEditContent_containers .multiselect_part fieldset {
  border: 1px solid #a3aec4;
  border-radius: 0px;
  height: 2.8rem !important;
  top: 4px;
}
.AddEditContent_containers .AddEditContentcontent {
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  height: calc(100vh - 66px);
  scrollbar-width: none;
}
.AddEditContent_containers .input-wrapper {
  position: relative;
  width: 100%;
}
.AddEditContent_containers input {
  border: 1px solid gray;
  border-radius: 6px;
  position: relative;
  width: 92%;
  height: 2.3rem;
  margin: 10px;
  line-height: 6ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 0.5rem;
}
.AddEditContent_containers label {
  position: absolute;
  top: 0.2ex;
  z-index: 1;
  left: 2em;
  background-color: white;
  padding: 0 5px;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #0c3688;
}
.AddEditContent_containers .AddEditContent_panel .panel-all {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 98%;
  margin: 1rem auto;
  font-family: Nunito;
  font-weight: 600;
  font-size: 20px;
  color: rgb(16, 19, 46);
  white-space: nowrap;
}
.AddEditContent_containers .AddEditContent_panel .panel-all .AddEditContent_Close {
  height: 40px;
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #FFFFFF;
  border: none;
  padding: 0px 30px;
}
.AddEditContent_containers .hero-section {
  display: flex;
  justify-content: left;
  width: 90.8%;
  border-radius: 6px;
  background: #ffffff;
  margin: 1rem;
}
.AddEditContent_containers .hero-section_div {
  width: 34%;
}
.AddEditContent_containers .title-input {
  margin: 1rem;
  width: 90%;
}
.AddEditContent_containers .text-field {
  border: 1px solid gray;
  border-radius: 0px;
  position: relative;
  width: 100%;
  margin: 10px;
  line-height: 3ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.7rem 0.5rem;
  height: 3.87rem;
  resize: none;
}
.AddEditContent_containers .select-file .text-field {
  width: 93%;
}
.AddEditContent_containers .text-description {
  border: 1px solid gray;
  border-radius: 0px;
  position: relative;
  width: 100%;
  margin: 10px;
  line-height: 4ex;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.7rem 0.5rem;
  height: 6rem;
  resize: none;
}
.AddEditContent_containers .multiple_input {
  width: 100%;
  display: flex;
  align-items: center;
  margin: 0rem 1rem;
}
.AddEditContent_containers .file-suggestion {
  font-family: "Nunito";
  font-size: 12px;
  font-style: italic;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: -0.2800000012px;
  text-align: left;
  display: flex;
  justify-content: space-around;
}
.AddEditContent_containers .content-type {
  width: 30%;
}
.AddEditContent_containers .upload_text {
  font-weight: 700;
  background: none;
  color: #0C3688;
  text-decoration: none;
  padding: 2px 6px;
  cursor: pointer;
}
.AddEditContent_containers .upload_text:disabled {
  color: #6684bf;
}
.AddEditContent_containers .upload-btn-flex {
  display: flex;
  flex-wrap: nowrap;
}
.AddEditContent_containers .upload-download-button {
  font-weight: 700;
  background: none;
  color: #0C3688;
  text-decoration: none;
  padding: 2px 6px;
  cursor: pointer;
  margin-left: 10px;
}
.AddEditContent_containers .upload-download-button:disabled {
  color: #6684bf;
}
.AddEditContent_containers .AddEditContent_submit {
  width: 15%;
  height: 40px;
  background: #0C3688;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #FFFFFF;
  border: none;
}
.AddEditContent_containers .AddEditContent_submit:disabled,
.AddEditContent_containers .AddEditContent_submit:disabled:hover {
  width: 15%;
  height: 40px;
  background: #c0cdee !important;
  box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);
  border-radius: 8px 8px 8px 8px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 700;
  font-size: 1rem;
  color: #FFFFFF;
  border: none;
  margin-bottom: 4rem;
}
.AddEditContent_containers .select-file {
  width: 62.4%;
}
.AddEditContent_containers .select-wrapper {
  position: relative;
  display: block;
}
.AddEditContent_containers .AddEditContent-content-title {
  position: absolute;
  right: 0px;
  z-index: 4;
  top: 60%;
  font-size: 13px;
}
:dir(rtl) .AddEditContent_containers .AddEditContent-content-title {
  right: auto;
  left: 0;
}
.AddEditContent_containers .AddEditContent-content-description {
  position: absolute;
  right: 0px;
  z-index: 4;
  top: 72%;
  font-size: 13px;
}
:dir(rtl) .AddEditContent_containers .AddEditContent-content-description {
  right: auto;
  left: 0;
}
.AddEditContent_containers .content-desc {
  position: absolute;
  left: 82%;
  z-index: 4;
  bottom: 0;
  font-size: 13px;
}
.AddEditContent_containers select {
  border: 1px solid gray;
  border-radius: 0px !important;
  position: relative;
  line-height: 6ex;
  width: 96%;
  height: 2.5rem;
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 0.5rem;
}
.AddEditContent_containers select:required:invalid {
  color: gray !important;
}
.AddEditContent_containers option:not(:first-of-type) {
  color: black !important;
}
.AddEditContent_containers .selectfileeditcontent {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0px 20px;
  border: 1px solid gray;
  height: 40px;
  width: 61%;
}
.AddEditContent_containers .upload_inp {
  border: none !important;
  height: 38px;
  outline: none;
}
.AddEditContent_containers ::placeholder {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0rem 0.5rem;
}
.AddEditContent_containers .footer_div {
  margin-top: 1rem;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
}
.AddEditContent_containers .header_border {
  background: #C0C8DA;
  height: 2.4rem;
  border: 1px solid #C0C8DA;
}
.AddEditContent_containers .header_border > img {
  margin: 0.9rem 1rem;
}
.AddEditContent_containers .header_border > span {
  font-family: "Nunito";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  letter-spacing: -0.28px;
  margin: 0.7rem 1rem;
}

@media screen and (max-width: 768px) {
  .AddEditContent {
    width: 100%;
    height: 100vh;
    background: #ffffff;
  }
  .AddEditContent_containers .sidebar {
    width: 100%;
    background: #dde7f5;
  }
  .AddEditContent_container {
    width: 100%;
    display: flex;
    flex-direction: column;
  }
  .AddEditContent_containers .AddEditContentcontent {
    width: 100%;
    background: #ffffff;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 90vh;
  }
  .AddEditContent_containers .hero-section {
    display: flex;
    justify-content: left;
    width: 97%;
    border-radius: 6px;
    background: #ffffff;
    flex-direction: column;
    margin: 1rem auto;
    padding: 0.6rem;
  }
  .AddEditContent_containers .hero-section_div {
    width: 100%;
  }
  .AddEditContent_containers .AddEditContent_submit {
    width: fit-content !important;
  }
  .AddEditContent_containers .text-field {
    width: 98%;
  }
  .AddEditContent_containers .text-description {
    width: 98%;
  }
  .AddEditContent-content-title {
    right: 20px;
    left: auto !important;
  }
  .AddEditContent-content-description {
    right: 20px;
    left: auto !important;
  }
  .hero-section_div select {
    width: 100% !important;
    margin: 10px auto !important;
  }
  .AddEditContent_containers .selectfileeditcontent {
    width: 66%;
  }
}
@media screen and (max-width: 480px) {
  .AddEditContent_containers .multiple_input {
    margin: 0rem auto;
    flex-direction: column;
  }
  .content-type {
    width: 100% !important;
  }
  .AddEditContent_containers .selectfileeditcontent {
    width: 96%;
  }
  .AddEditContent_containers .title-input {
    margin-left: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProductTraining/EditContent/AddEditContent.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;EACA,aAAA;AACJ;AACI;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACR;AAEI;EACI,UAAA;EACA,mBAAA;AAAR;AAGI;EACI,yBAAA;AADR;AAII;EACI,oBAAA;EACA,oBAAA;AAFR;AAIQ;EACI,qBAAA;EACA,sBAAA;AAFZ;AAMI;EACI,yBAAA;EACA,iBAAA;AAJR;AAOM;EACE,4BAAA;EACA,sBAAA;EACA,yBAAA;AALR;AAQM;EACE,yBAAA;EACA,kBAAA;EACA,yBAAA;EACA,QAAA;AANR;AASI;EACI,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,0BAAA;EACA,qBAAA;AAPR;AAUI;EACI,kBAAA;EACA,WAAA;AARR;AAWI;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AATR;AAYI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAVR;AAcQ;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,mBAAA;AAZZ;AAcY;EACI,YAAA;EACA,mEAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AAZhB;AAiBI;EACI,aAAA;EACA,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAfR;AAkBI;EACI,UAAA;AAhBR;AAmBI;EACI,YAAA;EACA,UAAA;AAjBR;AAoBI;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,eAAA;EACA,YAAA;AAlBR;AAqBI;EACI,UAAA;AAnBR;AAsBI;EACI,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AApBR;AAuBI;EACI,WAAA;EACA,aAAA;EACA,mBAAA;EACA,iBAAA;AArBR;AAwBI;EACI,qBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,6BAAA;AAtBR;AA0BI;EACI,UAAA;AAxBR;AA2BI;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;AAzBR;AA2BI;EACI,cAAA;AAzBR;AA4BI;EACI,aAAA;EACA,iBAAA;AA1BR;AA4BI;EACI,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AA1BR;AA4BI;EACI,cAAA;AA1BR;AA6BI;EACI,UAAA;EACA,YAAA;EACA,mBAAA;EACA,8CAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;AA3BR;AA8BI;;EAEI,UAAA;EACA,YAAA;EACA,8BAAA;EACA,8CAAA;EACA,8BAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;AA5BR;AA+BI;EACI,YAAA;AA7BR;AAgCI;EACI,kBAAA;EACA,cAAA;AA9BR;AAgCI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AA9BR;AAgCQ;EACI,WAAA;EACA,OAAA;AA9BZ;AAiCI;EACI,kBAAA;EACA,UAAA;EACA,UAAA;EACA,QAAA;EACA,eAAA;AA/BR;AAiCQ;EACI,WAAA;EACA,OAAA;AA/BZ;AAmCI;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,eAAA;AAjCR;AAoCI;EACI,sBAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAlCR;AAqCI;EACI,sBAAA;AAnCR;AAsCI;EACI,uBAAA;AApCR;AAuCI;EACI,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,iBAAA;EACA,sBAAA;EACA,YAAA;EACA,UAAA;AArCR;AAwCI;EACI,uBAAA;EACA,YAAA;EACA,aAAA;AAtCR;AAyCI;EACI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAvCR;AA0CI;EACI,gBAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;AAxCR;AA2CI;EACI,mBAAA;EACA,cAAA;EACA,yBAAA;AAzCR;AA4CI;EACI,mBAAA;AA1CR;AA6CI;EAEI,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA5CR;;AAgDA;EACI;IACI,WAAA;IACA,aAAA;IACA,mBAAA;EA7CN;EAgDE;IACI,WAAA;IACA,mBAAA;EA9CN;EAiDE;IACI,WAAA;IACA,aAAA;IACA,sBAAA;EA/CN;EAkDE;IACI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,YAAA;EAhDN;EAmDE;IACI,aAAA;IACA,qBAAA;IACA,UAAA;IACA,kBAAA;IACA,mBAAA;IACA,sBAAA;IACA,iBAAA;IACA,eAAA;EAjDN;EAoDE;IACI,WAAA;EAlDN;EAqDE;IACI,6BAAA;EAnDN;EAsDE;IACI,UAAA;EApDN;EAuDE;IACI,UAAA;EArDN;EAwDE;IACI,WAAA;IACA,qBAAA;EAtDN;EAwDE;IACI,WAAA;IACA,qBAAA;EAtDN;EAyDE;IACI,sBAAA;IACA,4BAAA;EAvDN;EA0DE;IACI,UAAA;EAxDN;AACF;AA4DA;EAEI;IACI,iBAAA;IACA,sBAAA;EA3DN;EA8DE;IACI,sBAAA;EA5DN;EA+DE;IACI,UAAA;EA7DN;EAgEE;IACI,cAAA;EA9DN;AACF","sourcesContent":[".AddEditContent_containers {\n    overflow: hidden;\n    height: 100vh;\n\n    .AddEditContent_container {\n        width: 100%;\n        display: flex;\n        overflow: hidden;\n    }\n\n    .sidebar {\n        width: 20%;\n        background: #dde7f5;\n    }\n\n    .multiselect_input {\n        min-width: 80% !important;\n    }\n\n    .multiselect-label{\n        top: 11px !important;\n        left: 4px !important;\n\n        :dir(rtl) & {\n            left: auto !important;\n            right: 30px !important;\n        }\n    }\n\n    .multiselect_input {\n        height: 2.8rem !important; \n        line-height: 45px;\n      }\n      \n      .multiselect_part {\n        margin-left: 10px !important; \n        width: 100% !important;\n        height: 2.8rem !important; \n      }\n      \n      .multiselect_part fieldset {\n        border: 1px solid #a3aec4;\n        border-radius: 0px; \n        height: 2.8rem !important; \n        top: 4px;\n      }\n\n    .AddEditContentcontent {\n        width: 100%;\n        overflow-y: auto;\n        overflow-x: hidden;\n        height: calc(100vh - 66px);\n        scrollbar-width: none;\n    }\n\n    .input-wrapper {\n        position: relative;\n        width: 100%;\n    }\n\n    input {\n        border: 1px solid gray;\n        border-radius: 6px;\n        position: relative;\n        width: 92%;\n        height: 2.3rem;\n        margin: 10px;\n        line-height: 6ex;\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 0rem 0.5rem;\n    }\n\n    label {\n        position: absolute;\n        top: 0.2ex;\n        z-index: 1;\n        left: 2em;\n        background-color: white;\n        padding: 0 5px;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 400;\n        font-size: 14px;\n        color: #0c3688;\n    }\n\n    .AddEditContent_panel {\n        .panel-all {\n            display: flex;\n            align-items: center;\n            justify-content: space-between;\n            width: 98%;\n            margin: 1rem auto;\n            font-family: Nunito;\n            font-weight: 600;\n            font-size: 20px;\n            color: rgb(16, 19, 46);\n            white-space: nowrap;\n\n            .AddEditContent_Close {\n                height: 40px;\n                background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n                border-radius: 8px 8px 8px 8px;\n                font-family: 'Poppins';\n                font-style: normal;\n                font-weight: 700;\n                font-size: 1rem;\n                color: #FFFFFF;\n                border: none;\n                padding: 0px 30px;\n            }\n        }\n    }\n\n    .hero-section {\n        display: flex;\n        justify-content: left;\n        width: 90.8%;\n        border-radius: 6px;\n        background: #ffffff;\n        margin: 1rem;\n    }\n\n    .hero-section_div {\n        width: 34%;\n    }\n\n    .title-input {\n        margin: 1rem;\n        width: 90%;\n    }\n\n    .text-field {\n        border: 1px solid gray;\n        border-radius: 0px;\n        position: relative;\n        width: 100%;\n        margin: 10px;\n        line-height: 3ex;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 0.7rem 0.5rem;\n        height: 3.87rem;\n        resize: none;\n    }\n\n    .select-file .text-field{\n        width: 93%;\n    }\n\n    .text-description {\n        border: 1px solid gray;\n        border-radius: 0px;\n        position: relative;\n        width: 100%;\n        margin: 10px;\n        line-height: 4ex;\n        font-family: \"Nunito\";\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 0.7rem 0.5rem;\n        height: 6rem;\n        resize: none;\n    }\n\n    .multiple_input {\n        width: 100%;\n        display: flex;\n        align-items: center;\n        margin: 0rem 1rem;\n    }\n\n    .file-suggestion {\n        font-family: \"Nunito\";\n        font-size: 12px;\n        font-style: italic;\n        font-weight: 500;\n        line-height: 16px;\n        letter-spacing: -0.2800000011920929px;\n        text-align: left;\n        display: flex;\n        justify-content: space-around;\n\n    }\n\n    .content-type {\n        width: 30%;\n    }\n\n    .upload_text {\n        font-weight: 700;\n        background: none;\n        color: #0C3688;\n        text-decoration: none;\n        padding: 2px 6px;\n        cursor: pointer;\n    }\n    .upload_text:disabled{\n        color: #6684bf;\n    }\n    \n    .upload-btn-flex{\n        display: flex;\n        flex-wrap: nowrap;\n    }\n    .upload-download-button{\n        font-weight: 700;\n        background: none;\n        color: #0C3688;\n        text-decoration: none;\n        padding: 2px 6px;\n        cursor: pointer;\n        margin-left: 10px;\n    }\n    .upload-download-button:disabled{\n        color: #6684bf;\n    }\n\n    .AddEditContent_submit {\n        width: 15%;\n        height: 40px;\n        background: #0C3688;\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 8px 8px 8px 8px;\n        font-family: 'Poppins';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 1rem;\n        color: #FFFFFF;\n        border: none;\n    }\n   \n    .AddEditContent_submit:disabled,\n    .AddEditContent_submit:disabled:hover {\n        width: 15%;\n        height: 40px;\n        background: #c0cdee !important;\n        box-shadow: 0px 3px 10px rgba(8, 50, 132, 0.4);\n        border-radius: 8px 8px 8px 8px;\n        font-family: 'Poppins';\n        font-style: normal;\n        font-weight: 700;\n        font-size: 1rem;\n        color: #FFFFFF;\n        border: none;\n        margin-bottom: 4rem;\n    }\n\n    .select-file {\n        width: 62.4%;\n    }\n\n    .select-wrapper {\n        position: relative;\n        display: block;\n    }\n    .AddEditContent-content-title {\n        position: absolute;\n        right: 0px;\n        z-index: 4;\n        top: 60%;\n        font-size: 13px;\n\n        :dir(rtl) & {\n            right: auto;\n            left: 0;\n        }\n    }\n    .AddEditContent-content-description {\n        position: absolute;\n        right: 0px;\n        z-index: 4;\n        top: 72%;\n        font-size: 13px;\n\n        :dir(rtl) & {\n            right: auto;\n            left: 0;\n        }\n    }\n\n    .content-desc {\n        position: absolute;\n        left: 82%;\n        z-index: 4;\n        bottom: 0;\n        font-size: 13px;\n    }\n\n    select {\n        border: 1px solid gray;\n        border-radius: 0px !important;\n        position: relative;\n        line-height: 6ex;\n        width: 96%;\n        height: 2.5rem;\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 0rem 0.5rem;\n    }\n\n    select:required:invalid {\n        color: gray !important;\n    }\n\n    option:not(:first-of-type) {\n        color: black !important;\n    }\n\n    .selectfileeditcontent {\n        display: flex;\n        align-items: center;\n        justify-content: space-between;\n        padding: 0px 20px;\n        border: 1px solid gray;\n        height: 40px;\n        width: 61%;\n    }\n\n    .upload_inp {\n        border: none !important;\n        height: 38px;\n        outline: none;\n    }\n\n    ::placeholder {\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 600;\n        font-size: 16px;\n        padding: 0rem 0.5rem;\n    }\n\n    .footer_div {\n        margin-top: 1rem;\n        position: fixed;\n        left: 0;\n        bottom: 0;\n        width: 100%;\n    }\n\n    .header_border {\n        background: #C0C8DA;\n        height: 2.4rem;\n        border: 1px solid #C0C8DA;\n    }\n\n    .header_border>img {\n        margin: 0.9rem 1rem;\n    }\n\n    .header_border>span {\n\n        font-family: 'Nunito';\n        font-style: normal;\n        font-weight: 500;\n        font-size: 12px;\n        line-height: 16px;\n        display: flex;\n        align-items: center;\n        letter-spacing: -0.28px;\n        margin: 0.7rem 1rem;\n    }\n}\n\n@media screen and (max-width:768px) {\n    .AddEditContent {\n        width: 100%;\n        height: 100vh;\n        background: #ffffff;\n    }\n\n    .AddEditContent_containers .sidebar {\n        width: 100%;\n        background: #dde7f5;\n    }\n\n    .AddEditContent_container {\n        width: 100%;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .AddEditContent_containers .AddEditContentcontent {\n        width: 100%;\n        background: #ffffff;\n        overflow-y: scroll;\n        overflow-x: hidden;\n        height: 90vh;\n    }\n\n    .AddEditContent_containers .hero-section {\n        display: flex;\n        justify-content: left;\n        width: 97%;\n        border-radius: 6px;\n        background: #ffffff;\n        flex-direction: column;\n        margin: 1rem auto;\n        padding: 0.6rem;\n    }\n\n    .AddEditContent_containers .hero-section_div {\n        width: 100%;\n    }\n\n    .AddEditContent_containers .AddEditContent_submit {\n        width: fit-content !important;\n    }\n\n    .AddEditContent_containers .text-field {\n        width: 98%;\n    }\n\n    .AddEditContent_containers .text-description {\n        width: 98%;\n    }\n\n    .AddEditContent-content-title {\n        right: 20px;\n        left: auto !important;\n    }\n    .AddEditContent-content-description {\n        right: 20px;\n        left: auto !important;\n    }\n\n    .hero-section_div select{\n        width: 100% !important;\n        margin: 10px auto !important;\n    }\n\n    .AddEditContent_containers .selectfileeditcontent {\n        width: 66%;\n    }\n}\n\n\n@media screen and (max-width:480px) {\n\n    .AddEditContent_containers .multiple_input {\n        margin: 0rem auto;\n        flex-direction: column;\n    }\n\n    .content-type {\n        width: 100% !important;\n    }\n\n    .AddEditContent_containers .selectfileeditcontent {\n        width: 96%;\n    }\n\n    .AddEditContent_containers .title-input {\n        margin-left: 0;\n    }\n    \n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
